
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_k5dlb_basdd_99",
  "top-navigation": "awsui_top-navigation_k5dlb_basdd_117",
  "padding-box": "awsui_padding-box_k5dlb_basdd_152",
  "medium": "awsui_medium_k5dlb_basdd_162",
  "narrow": "awsui_narrow_k5dlb_basdd_162",
  "virtual": "awsui_virtual_k5dlb_basdd_173",
  "hidden": "awsui_hidden_k5dlb_basdd_177",
  "\t": "awsui_\t_k5dlb_basdd_1",
  "identity": "awsui_identity_k5dlb_basdd_189",
  "identity-link": "awsui_identity-link_k5dlb_basdd_192",
  "no-logo": "awsui_no-logo_k5dlb_basdd_212",
  "logo": "awsui_logo_k5dlb_basdd_216",
  "title": "awsui_title_k5dlb_basdd_228",
  "inputs": "awsui_inputs_k5dlb_basdd_243",
  "search": "awsui_search_k5dlb_basdd_251",
  "search-expanded": "awsui_search-expanded_k5dlb_basdd_255",
  "utilities": "awsui_utilities_k5dlb_basdd_259",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_basdd_270",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_basdd_291",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_basdd_296",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_basdd_305",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_basdd_313",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_basdd_317",
  "offset-right-none": "awsui_offset-right-none_k5dlb_basdd_321",
  "offset-right-l": "awsui_offset-right-l_k5dlb_basdd_325",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_basdd_329",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_basdd_334",
  "overflow-menu": "awsui_overflow-menu_k5dlb_basdd_334",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_basdd_378",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_basdd_386",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_basdd_398",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_basdd_404",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_basdd_408",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_basdd_412",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_basdd_416",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_basdd_457",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_basdd_465",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_basdd_468",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_basdd_457",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_basdd_504",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_basdd_457",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_basdd_513",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_basdd_516",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_basdd_525",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_basdd_531",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_basdd_535",
  "expanded": "awsui_expanded_k5dlb_basdd_543"
};
  